import { Component } from "@angular/core";

@Component({
  selector: "onsip-instacall-dialpad",
  templateUrl: "./dialpad.component.html",
  styleUrls: ["./dialpad.scss"],
  standalone: false
})
export class DialpadComponent {
  dialpadButtons: Array<any> = [
    { number: "1", letters: "" },
    { number: "2", letters: "ABC" },
    { number: "3", letters: "DEF" },
    { number: "4", letters: "GHI" },
    { number: "5", letters: "JKL" },
    { number: "6", letters: "MNO" },
    { number: "7", letters: "PQRS" },
    { number: "8", letters: "TUV" },
    { number: "9", letters: "WXYZ" },
    { number: "*", letters: "" },
    { number: "0", letters: "OPER" },
    { number: "#", letters: "" }
  ];
}
